var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatePickerArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22994 0.671875H0.742188L4.92749 4.88708L9.1128 0.671875H5.62505H4.22994Z",
    fill: "#11B2B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerArrow);
export default __webpack_public_path__ + "static/media/date-picker-arrow.cff72a24d8e0fdd5a53fadd44ecec08c.svg";
export { ForwardRef as ReactComponent };